export default "__VITE_ASSET__DzCSJY_i__"